/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Links_Social_MediaInputs */

const de_commons_links_social_media = /** @type {(inputs: Commons_Links_Social_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soziale Medien`)
};

/** @type {(inputs: Commons_Links_Social_MediaInputs) => LocalizedString} */
const en_commons_links_social_media = de_commons_links_social_media;

/**

* @param {Commons_Links_Social_MediaInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_links_social_media = /** @type {((inputs?: Commons_Links_Social_MediaInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Links_Social_MediaInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_links_social_media(inputs)
	return en_commons_links_social_media(inputs)
});